import { FaInstagram, FaTwitter, FaFacebookF } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../asset/css/Footer.css";

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Aide */}
                <div>
                    <h4>Besoin d'aide</h4>
                    <ul>
                        <li>FAQ (à venir)</li>
                        <li>Conditions d'utilisation (à venir)</li>
                    </ul>
                </div>

                {/* Contact */}
                <div>
                    <Link to="/formEmail" className="footer-link">
                        <h4>Nous contacter</h4>
                    </Link>
                    <ul>
                        <li>Email du support : teamklynn@gmail.com</li>
                        <li>Téléphone : (à venir)</li>
                        <li>Formulaire (à venir)</li>
                    </ul>
                </div>

                {/* Réseaux */}
                <div>
                    <h4>Suivez-nous</h4>
                    <div className="footer-socials">
                        <a href="https://www.instagram.com" target="_blank" rel="noreferrer" className="instagram">
                            <FaInstagram />
                        </a>
                        <a href="https://x.com" target="_blank" rel="noreferrer" className="twitter">
                            <FaTwitter />
                        </a>
                        <a href="https://facebook.com" target="_blank" rel="noreferrer" className="facebook">
                            <FaFacebookF />
                        </a>
                    </div>
                </div>
            </div>

            <p className="footer-bottom">
                © {new Date().getFullYear()} Klynn. Tous droits réservés.
            </p>
        </footer>
    );
}
